import CryptoJS from "crypto-js";
import { DEV_URL } from "config/constants";

export const localStoreService = {
  saveData,
  // remove saveDatadyn,
  retrieveData,
  updateUserData,
  updateToken,
  // remove cleanSignJob,
  removeData,
  overWrite,
  // do not support updateNotificationReady,
};

// var localData = null;

const DATA_IDENTITY = "sajfgjdfgouhgf";
// const encryptKey = 'asdfadf3452452dfg';
const encryptKey = DEV_URL;

export function overWrite(data) {
  localStorage.removeItem(DATA_IDENTITY);

  const jsonString = JSON.stringify(data);
  const encryptedString = CryptoJS.AES.encrypt(
    jsonString,
    encryptKey,
  ).toString();
  localStorage.setItem(DATA_IDENTITY, encryptedString);

  // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
  return data;
}

export function removeData() {
  localStorage.removeItem(DATA_IDENTITY);
  localStorage.removeItem("_expiredTime");
  return null;
}

/* do not support *
export function updateNotificationReady () {
    const data = retrieveData();
    data.notificationready = true;
    const jsonString = JSON.stringify(data);
    const encryptedString = CryptoJS.AES.encrypt(jsonString, encryptKey).toString();
    localStorage.setItem(DATA_IDENTITY, encryptedString);

    return data;
}
 * do not support */

/* do not support *
export function saveDatadyn (logincode, userdata, locale='en', filepath=null, filename=null, jobtype=1, email, itimestring, signlocmarksString, s3path="" )
{
    // const currentData = retrieveData();
    const data = {
        logincode: logincode,
        userdata: userdata,
        locale: locale,
        jobtype: jobtype,
        filepath: filepath,
        filename: filename,
        // pk: pk,
        // lsi0: lsi0,

        inviteeeemail: email,
        inviteeitimestring: itimestring,
        signlocmarksString: signlocmarksString,
        s3path: s3path,
        // do not support notificationready: currentData.notificationready
    }

    const jsonString = JSON.stringify(data);
    const encryptedString = CryptoJS.AES.encrypt(jsonString, encryptKey).toString();
    localStorage.setItem(DATA_IDENTITY, encryptedString);
    // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
    // DEBUG console.log(data);
    return data;
}
 * do not support */

export function saveData(
  logincode,
  userdata,
  locale = "en",
  filepath = null,
  filename = null,
  jobtype = 1,
  jobopid = -1,
  signlocmarksString = null,
) {
  const data = {
    logincode: logincode,
    userdata: userdata,
    locale: locale,
    jobtype: jobtype,
    jobopid: jobopid,
    filepath: null,
    filename: null,
    signlocmarksString: null,
  };

  // save the file url
  if (filepath !== null) {
    data.filepath = filepath;
  }

  if (filename !== null) {
    data.filename = filename;
  }

  if (signlocmarksString != null) {
    data.signlocmarksString = signlocmarksString;
  }

  const jsonString = JSON.stringify(data);
  const encryptedString = CryptoJS.AES.encrypt(
    jsonString,
    encryptKey,
  ).toString();
  localStorage.setItem(DATA_IDENTITY, encryptedString);

  // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
  // DEBUG console.log(data);

  return data;
}

export function updateUserData(
  firstname,
  middlename,
  lastname,
  fullname,
  initial,
  mfarequired,
  phonenumber,
) {
  const data = retrieveData();
  data.userdata.firstname = firstname;
  data.userdata.middlename = middlename;
  data.userdata.lastname = lastname;
  // data.userdata.suffix = suffix;
  data.userdata.fullname = fullname;
  data.userdata.initial = initial;
  data.userdata.mfarequired = mfarequired;
  data.userdata.phonenumber = phonenumber;

  const jsonString = JSON.stringify(data);
  const encryptedString = CryptoJS.AES.encrypt(
    jsonString,
    encryptKey,
  ).toString();
  localStorage.setItem(DATA_IDENTITY, encryptedString);

  // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
  // console.log(data); // DEBUG
  return data;
}

export function updateToken(token) {
  let data = retrieveData();
  data.userdata.tokencount = token;

  const jsonString = JSON.stringify(data);
  const encryptedString = CryptoJS.AES.encrypt(
    jsonString,
    encryptKey,
  ).toString();
  localStorage.setItem(DATA_IDENTITY, encryptedString);

  // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
  return data;
}

/* do not support *
export function cleanSignJob()
{
    let data = retrieveData();
    data.jobtype = 1;
    data.jobopid = -1;
    if ( data.filepath !== null && data.filepath !== undefined )
    {
        data.filepath = null;
    }

    if ( data.filename !== null && data.filename !== undefined )
    {
        data.filename = null;
    }

    if ( data.signlocmarksString != null && data.signlocmarksString !== undefined )
    {
        data.signlocmarksString = null;
    }
    
    const jsonString = JSON.stringify(data);
    const encryptedString = CryptoJS.AES.encrypt(jsonString, encryptKey).toString();
    localStorage.setItem(DATA_IDENTITY, encryptedString);

    // localStorage.setItem(DATA_IDENTITY, JSON.stringify(data));
    return data;
}
 * do not support */

export function retrieveData() {
  try {
    const encryptedString = localStorage.getItem(DATA_IDENTITY);

    if (encryptedString === undefined || encryptedString === null) {
      return null;
    }

    const bytes = CryptoJS.AES.decrypt(encryptedString, encryptKey);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      return null;
    }

    const data = JSON.parse(decryptedString);
    if (data !== null && data !== undefined) {
      return data;
    }

    return null;
  } catch (error) {
    console.warn("retrieveData error:", error);
    return null;
  }
}
